<template>
  <div class="container" ref="content">
    <button class="fixed-top turqouse" @click="getLocation()">Hitta koordinater</button>
    <b-form @submit.prevent="setInputData(name, adress, postnr, ort, fastBet, email,
                    color, phone, fk, ttt, dthv, fthv, invoiced, lawnmover_checked, water_checked, owncable_checked, customerComments,
                   dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat)">
      <div class="flex-grid">
        <div class="col">
          <b-form-group label="Namn">
            <b-form-input v-model="name"/>
          </b-form-group>

          <b-form-group label="Ort">
            <b-form-input v-model="ort"/>
          </b-form-group>

          <b-form-group label="E-post" description="">
            <b-form-input v-model="email" type="email"/>
          </b-form-group>

          <b-form-group label="Fastighetsbet">
            <b-form-input v-model="fastBet"  />
          </b-form-group>

          <b-form-group label="lat">
            <b-form-input v-model="lat"  />
          </b-form-group>
        </div>

        <div class="col">
          <b-form-group label="Adress">
            <b-form-input v-model="adress" />
          </b-form-group>

          <b-form-group label="Postnr">
            <b-form-input v-model="postnr"/>
          </b-form-group>

          <b-form-group label="Telefon">
            <b-form-input v-model="phone"/>
          </b-form-group>

          <b-form-group label="Kundfärg:">
            <b-form-select v-model="color" :options="cable_colors" required class="rounded-0"/>
          </b-form-group>

          <b-form-group label="long">
            <b-form-input v-model="lon" />
          </b-form-group>
        </div>

        <div class="col">
          <h3>Status</h3>
          <b-form-checkbox id="fk" value="fk" unchecked-value="fk_not_done" v-model="fk"  > Förprojektering klar </b-form-checkbox>
          <b-form-checkbox id="ttt" value="ttt" unchecked-value="ttt_not_done" v-model="ttt"> Tillträde till tomtmar </b-form-checkbox>
          <b-form-checkbox id="dthv" value="dthv" unchecked-value="dthv_not_done" v-model="dthv"> Duct till Husvägg </b-form-checkbox>
          <b-form-checkbox id="fthv" value="fthv" unchecked-value="fthv_not_done" v-model="fthv"> Fiber till Husvägg </b-form-checkbox>
          <b-form-checkbox id="invoiced" value="invoiced" unchecked-value="invoiced_not_done" v-model="invoiced"> Fakturerad </b-form-checkbox>
        </div>

        <div class="col">
          <h3>Övrigt</h3>
          <b-form-checkbox v-model="lawnmover_checked" name="check-button-lawnmover" switch> Gräsklipparkabel </b-form-checkbox>
          <b-form-checkbox v-model="water_checked" name="check-button-water" switch> Sommarvattenslang </b-form-checkbox>
          <b-form-checkbox v-model="owncable_checked" name="check-button-owncable" switch> Belysningskabel eller egen kabel </b-form-checkbox>
        </div>
      </div>

      <div class="flex-grid">
        <div class="col">
          <b-form-textarea v-model="customerComments" placeholder="Kundkommentarer" rows="7" max-rows="20" />
        </div>
      </div>

      <hr>

      <div class="flex-grid">
        <div class="col">
          <h4>Planerad försyn</h4>
          <flat-pickr v-model="dateForsyn" placeholder="Välj datum"></flat-pickr>
        </div>
        <!--      <p v-if="datum_forsyn!=null">Valt datum {{datum_forsyn}}</p>-->

        <div class="col">
          <h4>Önskad tid</h4>
          <vue-single-select
                  v-model="timeForsyn"
                  :options="tForsyn"
                  placeholder="Sök tid"
                  value=""/>
        </div>

        <div class="col"></div>
        <div class="col"></div>
      </div>

      <div class="flex-grid">
        <div class="col">
          <h4>Planerad grävning</h4>
          <flat-pickr v-model="dateDigging" placeholder="Välj datum"></flat-pickr>
        </div>
        <!--    <p v-if="datum_digging!=null">Valt datum {{datum_digging}}</p>-->

        <div class="col">
          <h4>Önskad tid</h4>
          <vue-single-select
                  v-model="timeDigging"
                  :options="tDigging"
                  placeholder="Sök tid"
                  value=""/>
        </div>

        <div class="col"></div>
        <div class="col"></div>
      </div>

      <hr>

      <div class="flex-grid">
        <div class="col">
          <h4>Välj bildkategori </h4>
          <div class="select-dropdown">
            <label>
              <select v-on:change="getText" v-model="imgCategory" >
                <option v-for="choice in choices" v-bind:value="choice.value">{{ choice.text }}</option>
              </select>
            </label>
          </div>
        </div>
      </div>

      <div class="flex-grid">
        <div class="col">
          <div class="base-image-input"
               :style="{ 'background-image': `url(${imageData})` }" @click="chooseImage">
            <span v-if="!imageData" class="placeholder">
                Välj bild
            </span>
            <input class="file-input" ref="fileInput" type="file"
                   v-bind:imagetype="images_forsyn + choiceText"
                   :state="Boolean(images_forsyn)"
                   :data-type="images_forsyn"
                   @input="onSelectFile($event, choiceText)">
          </div>
        </div>

        <div class="col"></div>
        <div class="col"></div>
      </div>

      <div class="flex-grid">
        <div class="col">
          <b-button type="submit" class="button turqouse"> Save </b-button>
        </div>

        <div class="col">
          <b-button type="reset" class="button red" @click="clearForsyn()">Clear</b-button>
        </div>

        <div class="col"></div>
        <div class="col"></div>
      </div>

      <div class="flex-grid">
        <div class="col">
          <!--   <div class="alert alert-success" role="alert">
               Success alert!
             </div>-->
        </div>
      </div>
    </b-form>

    <hr>

    <div class="flex-grid">
      <div class="col">
        <h4>Försyn</h4>

        <img class="image" v-for="(image, i) in images_forsyn" :src="image" :key="i" @click="images_forsyn_index = i">
        <vue-gallery-slideshow :images="images_forsyn" :index="images_forsyn_index" @close="images_forsyn_index = null"></vue-gallery-slideshow>
      </div>

      <div class="col">
        <h4>Före</h4>
        <img class="image" v-for="(image, i) in images_before" :src="image" :key="i" @click="images_before_index = i">
        <vue-gallery-slideshow :images="images_before" :index="images_before_index" @close="images_before_index = null"></vue-gallery-slideshow>
      </div>
    </div>

    <div class="flex-grid">
      <div class="col">
        <h4>Grävning</h4>
        <img class="image" v-for="(image, i) in images_digging" :src="image" :key="i" @click="images_digging_index = i">
        <vue-gallery-slideshow :images="images_digging" :index="images_digging_index" @close="images_digging_index = null"></vue-gallery-slideshow>
      </div>

      <div class="col">
        <h4>Efter </h4>
        <img class="image" v-for="(image, i) in images_after" :src="image" :key="i" @click="images_after_index = i">
        <vue-gallery-slideshow :images="images_after" :index="images_after_index" @close="images_after_index = null"></vue-gallery-slideshow>
      </div>
    </div>

    <div class="flex-grid">
      <div class="col">
        <h4>Övrigt</h4>
        <img class="image" v-for="(image, i) in images_other" :src="image" :key="i" @click="images_other_index = i">
        <vue-gallery-slideshow :images="images_other" :index="images_other_index" @close="images_other_index = null"></vue-gallery-slideshow>
      </div>
    </div>
  </div>
</template>

<script>
  import { db, fbapp } from '../main'
  import { storage } from 'firebase';
  import VueGallery from 'vue-gallery';
  import VueGallerySlideshow from 'vue-gallery-slideshow';
  import VueSingleSelect from "vue-single-select";

  export default {
    name: "forsynadd",
    components: {
      'gallery': VueGallery,
      VueGallerySlideshow,
      VueSingleSelect
    },

    data() {
      return {
        createdAt: new Date(),
        msg: String,
        imageFile: null,
        imgCategory: '',
        imgCategories: ["Före", "Försyn", "Grävning", "Efter", "Övrigt"],
        timeForsyn: '',
        timeDigging: '',
        tForsyn: ['9-11', '12-14'],
        tDigging: ['9-11', '12-14'],
        dateDigging: '',
        dateForsyn: '',
        choices: [
          {value: "forsyn", text: "Försyn"},
          {value: "before", text: "Före"},
          {value: "digging", text: "Grävning"},
          {value: "after", text: "Efter"},
          {value: "other", text: "Övrigt"},
        ],
        choiceId: '',
        name: '',
        adress: '',
        postnr: '',
        ort: '',
        fastBet: '',
        email: '',
        color: '',
        phone: '',
        fk: false,
        ttt: false,
        dthv: false,
        fthv: false,
        invoiced: false,
        lawnmover_checked: false,
        water_checked: false,
        owncable_checked: false,
        customerComments: '',
        cable_colors: [{text: 'Välj färg på duct', value: null},
          'VI', 'BL', 'BR', 'GR', 'VL', 'GRÅ', 'RO', 'RÖ', 'SV', 'TU', 'OR', 'GU'],
        customers: [],
        images_forsyn: [],
        images_forsyn_index: null,
        images_before: [],
        images_before_index: null,
        images_after: [],
        images_after_index: null,
        images_digging: [],
        images_digging_index: null,
        images_other: [],
        images_other_index: null,
        image: '',
        image_before: '',
        imageUrl: '',
        imageData: '',  // we will store base64 format of image in this string
        images: [],
        index: null,
        saveImages: [],
        choiceText: '',
        noImages: null,
        lon: '',
        lat: '',
        showAlert: false,
      }
    },

    async beforeMount() {
      /*   await this.getForsynIDAndSetForsynID();
      await console.log('getForsynID: ' + this.getForsynID());
      await this.firestore();*/
    },

    computed: {},
    methods: {
      firestore() {
        return {
          customers: db.collection('customers').orderBy('createdAt'),
          customer_images: db.collection('customers_images')
        }
      },

      /* Async/promise funktion, sätter ID, sparar ID i vuex, hämtar ID ifrån vuex */
      async getForsynIDAndSetForsynID() {
        await console.log('Försyn ID: ' + this.$route.params.id);
        await this.setForsynID(this.$route.params.id);                 // Tilldelar ID i redux
        await this.getForsynData(this.$route.params.id);
      },

      /* Om det finns ett ID, Radera tidigare ID och Spara nytt ID globalt i Vuex */
    async setForsynID(forsynID) {
        if ((forsynID !== undefined) && (forsynID !== null) && (forsynID !== '')) {
        await this.deleteForsynID();
         await this.$store.commit('ADD_TO_ID', forsynID);
        } else {
        await  console.log(('ID is undefined, null or empty '))
        }
      },

      async deleteForsynID(ID) {                    /* Tar bort sparade ID */
       await this.$store.commit('DELETE_ID', ID);
      },

      /* If it´s possible to retrieve current geo location, get showLocation */
      getLocation: function () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.showLocation);
        } else {
          this.error = "Geolocation is not supported.";
        }
      },

      /* Retrieving geo current location and display current coordinates */
      showLocation: function (position) {
        let lat = this.lat = position.coords.latitude;
        let lon = this.lon = position.coords.longitude;
        //this.setMap(lat, lon);
      },


      chooseImage() {
        this.$refs.fileInput.click()
      },

      getText() {
        const values = this.choices.map(function (o) {
          return o.value
        });
        const index = values.indexOf(this.imgCategory);
        //  console.log(this.choiceText = this.choices[index].value);
        this.saveNewImages(this.choiceText = this.choices[index].value);
      },

      saveNewImages(images) {
        this.saveImages.push(this.images);
      },

      onSelectFile($event, imgCategory) {
        this.onFilePicked($event, imgCategory);
        const input = this.$refs.fileInput;
        const files = input.files;
        if (files && files[0]) {
          const reader = new FileReader;
          reader.onload = e => {
            this.imageData = e.target.result
          };
          reader.readAsDataURL(files[0]);
          this.$emit('input', files[0]);
        }
      },

      onFilePicked(event, imgCategory) {
        console.log(+'event + imgCategory ' + event + imgCategory);
        const files = event.target.files;
        let filename = files[0].name;
        if (filename.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file!')
        }
        const fileReader = new FileReader();
        fileReader.addEventListener('load', () => {
          this.imageUrl = fileReader.result
        });
        fileReader.readAsDataURL(files[0]);
        this.image = files[0];
        const imageData = {
          title: this.title,
          creatorId: fbapp.auth().currentUser.uid,
          image: this.image,
          forsynID: this.getForsynID()[0],
          imageType: imgCategory
        };
        /* Skickar objekt med info om bilden till store för att lagra hos firebase*/
        this.$store.dispatch('createImage', imageData)
      },
    },

    /* Get firebase storage */
    async getStorage() {
      return storage;
    },

    /* Get string ID */
    getStringID() {
      return JSON.stringify(this.getForsynID());
    },

    async setInputData(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced,
                       lawnmover_checked, water_checked, owncable_checked, customerComments,
                       dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat) {

      console.log('SetinputData: ' + name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv,
              invoiced, lawnmover_checked, water_checked, owncable_checked,
              customerComments, dateDigging, dateForsyn, timeDigging, timeForsyn,
              lon, lat);
      this.name = name;
      this.adress = adress;
      this.postnr = postnr;
      this.ort = ort;
      this.fastBet = fastBet;
      this.email = email;
      this.color = color;
      this.phone = phone;
      this.fk = fk;
      this.ttt = ttt;
      this.dthv = dthv;
      this.fthv = fthv;
      this.invoiced = invoiced;
      this.lawnmover_checked = lawnmover_checked;
      this.water_checked = water_checked;
      this.owncable_checked = owncable_checked;
      this.customerComments = customerComments;
      this.dateForsyn = dateForsyn;
      this.dateDigging = dateDigging;
      this.timeDigging = timeDigging;
      this.timeForsyn = timeForsyn;
      this.lon = lon;
      this.lat = lat;

      await this.addNewForsyn(name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced,
              lawnmover_checked, water_checked, owncable_checked, customerComments, dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat);
    },

    async addNewForsyn(name, adress, postnr, ort, fastBet, email,
                       color, phone, fk, ttt, dthv, fthv, invoiced,
                       lawnmover_checked, water_checked, owncable_checked, customerComments,
                       dateForsyn, dateDigging, timeDigging, timeForsyn, lon, lat) {
      await db.collection('customers').add({
        name, adress, postnr, ort, fastBet, email, color, phone, fk, ttt, dthv, fthv, invoiced,
        lawnmover_checked, water_checked, owncable_checked, customerComments,
        dateDigging, dateForsyn, timeDigging, timeForsyn, lon, lat});

      await this.$router.replace('/forsyn-list');   //Skickas vidare till försynList
      // await this.getStorage()
    },

      /* Clear fields and update site*/
      async clearForsyn() {
        await this.clearFields();
        await this.$router.replace('/forsynadd');   //Skickas vidare till försynList
      },

      async clearFields() {
        this.name = '';
        this.adress = '';
        this.postnr = '';
        this.ort = '';
        this.fastBet = '';
        this.email = '';
        this.color = '';
        this.phone = '';
        this.fk = false;
        this.ttt = false;
        this.dthv = false;
        this.fthv = false;
        this.invoiced = false;
        this.lawnmover_checked = false;
        this.water_checked = false;
        this.owncable_checked = false;
        this.customerComments = '';
        this.dateForsyn = '';
        this.dateDigging = '';
        this.timeDigging = '';
        this.timeForsyn = '';
        this.lon = '';
        this.lat = '';
      }
  }
</script>

<style scoped lang="scss">
  .container {
    text-align: start;
    margin: 10px;
    min-width: 50%;
    display: flex;
    flex-direction: column;
  }

  .flex-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

  .col {
    flex: 1;
    flex-basis: 20%;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
  }

  /* Inserting this collapsed row between two flex items will make
 * the flex item that comes after it break to a new row */
  .break {
    flex-basis: 100%;
    height: 0;
  }

  input, button,input[type=date]{
    padding: 5px 10px;
    border-radius: 2px;
    border: 1px solid #ddd;
  }

  button {
    padding: 10px 20px;
  }

  .button:hover,
  .button:active,
  .button:focus,
  .button:visited {
    box-shadow: none;
    border: 1px solid transparent;
  }


  /* Styling för select file btn */
  form {
    width: 100%;
    margin: 0 auto;
    text-align: left;
  }

  .image-preview {
    padding: 20px;
  }


  img .preview {
    width: 200px;
    background-color: white;
    padding: 5px;
  }

  img {
    padding: 5px;
    border: none;
    margin: 0;
  }

  .image {
    max-width: 50%;
  }

  label {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-weight: 400;
    font-size: 16pt;
  }

  .select-dropdown {
    background-color: white;
    max-width: 45%;

    select {
      font-family: Raleway, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif;
      font-weight: 400;
      color: #333;
      font-size: 12pt;
      max-width: 100%;
      padding: 8px 10px;
      border: 1px solid #ced4da;
      border-radius: 2px;
      background-color: transparent;
      &:active,
      &:focus {
        /*     outline: none;
             box-shadow: none;*/
      }
    }
    &:after {
      content: " ";
      position: absolute;
      top: 7%;
      right: 60%;
      width: 0;
      height: 0;
      /* border-left: 5px solid transparent;
       border-right: 5px solid transparent;
       border-top: 5px solid #aaa;*/
    }
  }

  .base-image-input {
    margin: 20px 0;
    display: block;
    width: 200px;
    height: 200px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
  }

  .placeholder {
    background: #F0F0F0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    font-family: Raleway, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif;
  }
  .placeholder:hover {
    background: #E0E0E0;
  }
  .file-input {
    display: none;
  }

  @media only screen and (max-width: 992px) {
    .container {
      min-width: 100%;
    }

    .col {
      flex: 1;
      flex-basis: 30%;
      display: flex;
      flex-direction: column;
      margin: 5px 0;
    }

    button {
      padding: 5px 10px;
    }

    select {
      font-size: 10pt;
    }
  }

  @media (max-width: 400px) {
    .flex-grid {
      display: block;
    }
  }
</style>
<!-- Du kan animera både på v-if (vanligast) och på v-show-->



// WEBPACK FOOTER //
// src/views/forsynadd.vue